import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from '@fcom/common/pipes';
import { UiTranslateModule } from '@fcom/ui-translate';
import { LqipImageModule } from '@fcom/common/components/images/lqip-image/lqip-image.module';

import { PromoCardComponent } from './promo-card.component';
import { IconsModule } from '../icons/icons.module';
import { ButtonModule } from '../buttons/button.module';
import { ImagesModule } from '../images/images.module';
import { TagModule } from '../tag/tag.module';

@NgModule({
  declarations: [PromoCardComponent],
  imports: [
    CommonModule,
    IconsModule,
    ButtonModule,
    ImagesModule,
    PipesModule,
    TagModule,
    UiTranslateModule,
    LqipImageModule,
  ],
  providers: [],
  exports: [PromoCardComponent],
})
export class PromoCardModule {}
